module.exports = __webpack_public_path__ + "img/whiteCircle.27aa9f1c.svg";